import React from 'react';
import PropTypes from 'prop-types';
import authClasess from './AuthView.module.scss';

export default function AuthView(props) {
  const { children } = props;
  return <div className={authClasess.auth}>{children}</div>;
}

AuthView.propTypes = {
  children: PropTypes.node,
};
